import { useQuery } from '@tanstack/react-query';
import { requestOfferByKey, requestOffers, requestOrderStatus } from '../offers/orders';

export function useGetOffers() {
    return useQuery({
        queryKey: ['offers'],
        queryFn: async ({ signal }) => (await requestOffers(signal)).data,
    });
}

export function useGetOfferByKey(offerKey: string | undefined) {
    return useQuery({
        queryKey: ['offers', offerKey],
        enabled: !!offerKey,
        queryFn: async ({ signal }) => (await requestOfferByKey(offerKey!, signal)).data,
    });
}

export function useGetOrderStatus(sessionId: string) {
    return useQuery({
        queryKey: [`stripeBilling-${sessionId}`],
        queryFn: async ({ signal }) => (await requestOrderStatus(sessionId, signal)).data,
        enabled: !!sessionId,
        refetchInterval(data, query) {
            if (data?.status === 'Success' || data?.status === 'PaymentFailed') {
                return false;
            }
            return 2000;
        },
    });
}
